import { STORAGE_KEY } from '@/constant/constant';
import { getRandomWeightedOption } from '@/utils/getRandomWeightedOption';
import { getLocal, setLocal, setSession } from '@/utils/storage';
import { commonApi, companyUUID, getQueryVariable, getShopifyUserId } from '@/service/api';
import { debug } from 'debug';
import { preload02Pop } from '@/service/strategy/dataStorage';
import { injectGoogleScript } from '@/utils/injectGoogle';
const log = debug('cartsee:request');

const getStrategy = () => {
  return new Promise((resolve, reject) => {
    const info = getLocal(STORAGE_KEY.AB_MAP);
    let abMapping = null;
    if (info) {
      try {
        abMapping = JSON.parse(info);
      } catch (error) {}
    }
    const coupon = getQueryVariable('coupon');
    const localExcludeProductIds = getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS);
    const localExcludeProductIdsVersion = getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS_VERSION);
    // 拼接参数
    const params = {
      cid: getLocal(STORAGE_KEY.CID) || null,
      formUid: getLocal(STORAGE_KEY.FORM_UID) || null,
      pathname: window?.location?.pathname,
      hostname: window?.location?.hostname,
      parameters: window?.location?.search,
      event: 'load',
      companyUUID: companyUUID,
      shopifyUserId: getShopifyUserId(),
      abMapping: abMapping,
      // load 带上排除商品版本，后端版本一致时不再重复返回大列表
      excludeProductIdsVersion:
        localExcludeProductIds && localExcludeProductIdsVersion ? localExcludeProductIdsVersion : null,
      // loginEmail: window?.cartq?.params?.customer?.email || '',
      userAgent: navigator?.userAgent
      // terminal: terminal ? 'pc' : 'mobile',
      // triggerEventType: actionType  // 0 欢迎订阅弹框  1 离开订阅弹框  2 加购订阅弹框  3 优惠券弹框  4 自定义订阅弹框  5 弃单弹窗
    };

    //优惠券弹框新增参数
    if (coupon) {
      params['templateMessageId'] = `${coupon}`.split('#')[0];
    }
    commonApi(params, 'form/out/load')
      .then((response) => {
        setSession(STORAGE_KEY.POPUP_LOAD_REQUEST_TIME, Date.now().toString());
        // 存储排除商品
        if (response?.data?.data?.excludeProductIds) {
          setLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS, JSON.stringify(response?.data?.data?.excludeProductIds));
        }
        // 保存排除商品列表版本，后续 checkFormSettings 版本一致时不再重复下发大列表
        if (response?.data?.data?.excludeProductIdsVersion) {
          setLocal(
            STORAGE_KEY.EXCLUDE_PRODUCT_IDS_VERSION,
            response?.data?.data?.excludeProductIdsVersion
          );
        }
        // 存储ipCountryCode
        if (response?.data?.data?.ipCountryCode) {
          setSession(STORAGE_KEY.IP_COUNTRY_CODE, response?.data?.data?.ipCountryCode);
        }
        // 存储公司静态资源地址
        const companyStaticUrl = response?.data?.data?.companyStaticUrl;
        if (companyStaticUrl) {
          setLocal(STORAGE_KEY.COMPANY_STATIC_URL, companyStaticUrl);
        }
        // 随机转盘coupon存储
        try {
          if (response?.data?.data?.rets) {
            for (const key in response.data.data.rets) {
              const item = response.data.data.rets[key];
              const { settings } = item;
              if (settings?.rules?.config?.wheelOptions && !settings.discountList) {
                // 数组加权随机
                const wheelOptions = settings.rules.config.wheelOptions;
                const selectedOption = getRandomWeightedOption(wheelOptions);

                // 设置转盘停止角度
                item.settings.rules.pointFinallyDeg = selectedOption.deg;
                // 设置选中的折扣码
                item.settings.rules.couponCode = selectedOption.coupon;
                item.settings.banner.bannerCouponCode = selectedOption.coupon;

                if (selectedOption.couponPrompt) {
                  item.settings.texts.couponPrompt = selectedOption.couponPrompt;
                }

                log('random coupon id=%s, wheelOptions=%o, pointFinallyDeg=%d, coupon=%s', item.id, wheelOptions, item.settings.rules.pointFinallyDeg, item.settings.rules.couponCode);
              }
              if (settings?.authList && settings?.authList.length > 0) {
                injectGoogleScript();
                log('Added mock authList to popup id=%s authList=%o', item.id, item.settings.authList);
              }
            }
            // 请求后预加载
            preload02Pop(response?.data?.data);
            // 存储品牌字体列表
            if (response?.data?.data?.companyFont) {
              window.localStorage.setItem('companyFontList', JSON.stringify(response?.data?.data?.companyFont));
            }
          }
        } catch (e) {
          console.log(e);
        }
        resolve(response?.data?.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const checkConfig = (config, type, globalSettingTimestamp) => {
  return new Promise((resolve, reject) => {
    const info = getLocal(STORAGE_KEY.AB_MAP);
    let abMapping = null;
    if (info) {
      try {
        abMapping = JSON.parse(info);
      } catch (error) {}
    }
    const localExcludeProductIds = getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS);
    const localExcludeProductIdsVersion = getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS_VERSION);
    // 拼接参数
    const params = {
      cid: getLocal(STORAGE_KEY.CID) || null,
      formUid: getLocal(STORAGE_KEY.FORM_UID) || null,
      companyUUID: companyUUID,
      shopifyUserId: getShopifyUserId(),
      eventType: type,
      config: config,
      abMapping: abMapping,
      globalSettingTimestamp: globalSettingTimestamp,
      excludeProductIdsVersion: localExcludeProductIds && localExcludeProductIdsVersion ? localExcludeProductIdsVersion : null
    };
    //优惠券弹框新增参数
    const coupon = getQueryVariable('coupon');
    if (coupon) {
      params['templateMessageId'] = `${coupon}`.split('#')[0];
    }
    // console.log('请求新数据');
    commonApi(params, 'form/out/checkFormSettings')
      .then((response) => {
        setSession(STORAGE_KEY.POPUP_LOAD_REQUEST_TIME, Date.now().toString());
        // 存储排除商品
        if (response?.data?.data?.excludeProductIds) {
          setLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS, JSON.stringify(response?.data?.data?.excludeProductIds));
        }
        // 后端会始终返回当前版本，确保本地版本随服务端保持一致
        if (response?.data?.data?.excludeProductIdsVersion) {
          setLocal(
            STORAGE_KEY.EXCLUDE_PRODUCT_IDS_VERSION,
            response?.data?.data?.excludeProductIdsVersion
          );
        }
        // 存储ipCountryCode
        if (response?.data?.data?.ipCountryCode) {
          setSession(STORAGE_KEY.IP_COUNTRY_CODE, response?.data?.data?.ipCountryCode);
        }
        // 存储公司静态资源地址
        const companyStaticUrl = response?.data?.data?.companyStaticUrl;
        if (companyStaticUrl) {
          setLocal(STORAGE_KEY.COMPANY_STATIC_URL, companyStaticUrl);
        }
        // 存储品牌字体列表
        if (response?.data?.data?.companyFont) {
          window.localStorage.setItem('companyFontList', JSON.stringify(response?.data?.data?.companyFont));
        }
        // 随机转盘coupon存储
        try {
          if (response?.data?.data?.config) {
            const { config } = response.data.data;
            for (const key in config) {
              const item = config[key];
              const { settings } = item;
              if (settings?.rules?.config?.wheelOptions && !settings.discountList) {
                // 数组加权随机
                const wheelOptions = settings.rules.config.wheelOptions;
                const selectedOption = getRandomWeightedOption(wheelOptions);

                // 设置转盘停止角度
                item.settings.rules.pointFinallyDeg = selectedOption.deg;
                // 设置选中的折扣码
                item.settings.rules.couponCode = selectedOption.coupon;
                item.settings.banner.bannerCouponCode = selectedOption.coupon;

                if (selectedOption.couponPrompt) {
                  item.settings.texts.couponPrompt = selectedOption.couponPrompt;
                }

                log('random coupon id=%s, wheelOptions=%o, pointFinallyDeg=%d, coupon=%s', item.id, wheelOptions, item.settings.rules.pointFinallyDeg, item.settings.rules.couponCode);
              }

              if (settings?.authList && settings?.authList.length > 0) {
                injectGoogleScript();
                log('Added mock authList to popup id=%s authList=%o', item.id, item.settings.authList);
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
        resolve(response?.data?.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export interface CheckEmailOrPhoneParams {
  /** 弹窗id */
  formId: string;
  /** 公司id */
  companyUUID: string;
  /** 邮箱 */
  email: string | null;
  /** 手机号 */
  phone: string | null;
}

/**
 * 检查邮箱或手机号是否已经提交过
 */
export const checkEmailOrPhone = (params: CheckEmailOrPhoneParams) => {
  return commonApi(params, 'form/out/signup/check');
};


export interface ContactStatusParams {
  companyUUID: string;
  email: string;
  type: 'email' | 'phone';
  phone: string;
  /**
   * 是否进行校验
   */
  validate?: boolean;
}

export interface ContactStatusResult {
  email: string;
  /** 订阅状态 */
  subscribeStatus: 0 | 1;
  /** 短信订阅状态 */
  smsSubscribeStatus: 0 | 1;
}

export const getContactStatus = (params: ContactStatusParams) => {
  return commonApi(params, 'contact/fetch');
}

export { getStrategy, checkConfig };
